import { makeStyles } from '@material-ui/core/styles';
import { GiftOrderSummaryItemSize } from './index';

export type CheckboxFieldProps = {
  size?: GiftOrderSummaryItemSize;
};

export const useStyles = makeStyles(() => ({
  textFont: {
    fontSize: ({ size }: CheckboxFieldProps) => (size === 'medium' ? 22 : 16),
    lineHeight: '18px',
  },
  productText: {
    fontSize: ({ size }: CheckboxFieldProps) => (size === 'medium' ? 22 : 12),
    lineHeight: '18px',
  },
  remainingAmountContainer: {
    height: 'max-content',
    borderTop: '1px solid #CFCED3',
  },
  spendAmount: {
    textTransform: 'uppercase',
    fontWeight: 300,
    color: '#5F5F5F',
  },
  remainingAmount: {
    textTransform: 'uppercase',
    fontWeight: 500,
  },
  cardsQuantityText: {
    fontSize: ({ size }: CheckboxFieldProps) => (size === 'medium' ? 14 : 10),
    lineHeight: '18px',
  },
}));
